<template>
  <th
    :class="
      cn(
        'h-10 px-2 text-left align-middle font-semibold [&:has([role=checkbox])]:pr-0 text-white/50 first:pl-0 last:pr-0',
        props.class
      )
    "
  >
    <slot />
  </th>
</template>

<script>
import { cn } from '../../utils.js';

export default {
  props: {
    class: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    return { props, cn };
  },
};
</script>
